import React from "react";
import { Document } from "@react-pdf/renderer";

import F280FirstPage from "../F280FirstPage";
import FormPage from "./FormPage";
import RoomByRoomPDFPage from "../RoomByRoomPDFPage";

// F280 report as a single vector PDF document (US Letter pages).
// Replaces the legacy html2canvas raster pipeline: real 8.5x11 pages,
// selectable text, small file size, and no DOM/canvas step (which was the
// source of the intermittent "black screen" export failures).
const F280PDF = ({
    displayData,
    inputFieldsData,
    calcPerformedBy,
    name,
    heatLossValue,
    latHeatGainValue,
    latentMultiplier,
    heatUnit,
    language = "en",
    includeRoomByRoomResults,
    roomByRoomResults,
    storeyCategories,
}) => {
    const { issuedForTheUseOf, projectNo, lot, site } = inputFieldsData || {};
    const { buildingLocation = {} } = displayData || {};
    const { cityProvince = "", postalCode = "", address = "" } = buildingLocation || {};

    return (
        <Document title={`${name}_f280_report_${language}`}>
            <F280FirstPage
                heatLossValue={heatLossValue}
                latHeatGainValue={latHeatGainValue}
                heatUnit={heatUnit}
                name={name}
                inputFieldsData={inputFieldsData}
                displayData={displayData}
                calcPerformedBy={calcPerformedBy}
                language={language}
                includeRoomByRoomResults={includeRoomByRoomResults}
            />
            <FormPage
                name={name}
                displayData={displayData}
                inputFieldsData={inputFieldsData}
                language={language}
                includeRoomByRoomResults={includeRoomByRoomResults}
            />
            {includeRoomByRoomResults && (
                <RoomByRoomPDFPage
                    latHeatGainValue={latHeatGainValue}
                    heatLossValue={heatLossValue}
                    includeRoomByRoomResults={includeRoomByRoomResults}
                    language={language}
                    issuedForTheUseOf={issuedForTheUseOf}
                    projectNo={projectNo}
                    name={name}
                    site={site}
                    lot={lot}
                    address={address}
                    cityProvince={cityProvince}
                    postalCode={postalCode}
                    roomByRoomResults={roomByRoomResults}
                    storeyCategories={storeyCategories}
                    latentMultiplier={latentMultiplier}
                />
            )}
        </Document>
    );
};

export default F280PDF;
